import { CustomVideoPlayer } from "@/components/ui/custom-video-player";

export function AdvertisingPlatformVideo() {
  return (
    <CustomVideoPlayer
      imageUrl="https://res.cloudinary.com/dvoreldfc/image/upload/v1782581070/ChatGPT_Image_Jun_27_2026_10_53_49_PM_rcfkqw.png"
      className="w-full h-full overflow-hidden"
    />
  );
}
